<template>
    <div :class="`g-card ${expandido ? '':'g-card-fechado'}`" ref="containerCard" id="containerCard">
        <div v-if="temCabecalho && !cabecalhoCustomizado" :class="`g-card-cabecalho ${corCabecalho !== '#ffffff' ? '':''}`">
            <slot name="cabecalho">
                <div class="g-card-icone-esquerda" v-if="iconeEsquerda">
                    <img class="g-card-img-icone-esquerda" :src="require(`@/assets/imgs/${iconeEsquerda}`)" />
                </div>

                <div class="g-card-titulo">
                    {{titulo}}
                </div>

                <div class="g-card-icone-direita" v-if="iconeDireita">
                    <img class="g-card-img-icone-direita" :src="require(`@/assets/imgs/${iconeDireita}`)" />
                </div>
            </slot>
            <div class="g-card-icone-expandir" v-on:click="expandirConteudo" v-if="expansivel">
                <div v-if="!setaExpansivelMarrom"><img class="g-card-img-icone-expandir" :src="require(`@/assets/imgs/icone_seta.svg`)" /></div>
                <div v-if="setaExpansivelMarrom"><img class="g-card-img-icone-expandir" :src="require(`@/assets/imgs/icone_seta_marrom.svg`)" /></div>
            </div>
        </div>

        <div v-if="temCabecalho && cabecalhoCustomizado" :class="`g-card-cabecalho ${corCabecalho !== '#ffffff' ? '':''}`">
            <div class="g-card-custom-header">
                <slot name="cabecalho">
                </slot>
            </div>
            <div class="g-card-icone-expandir" v-on:click="expandirConteudo" v-if="expansivel">
                <img class="g-card-img-icone-expandir" :src="require(`@/assets/imgs/icone_seta.svg`)" />
            </div>
        </div>

        <div :class="`g-card-conteudo ${expandido ? '':'g-card-conteudo-fechado'}`" id="conteudoCard">
            <slot></slot>
        </div>
    </div>
</template>

<script>
    import gCard from './g-card.js'
    export default gCard
</script>

<style scoped>
.g-card {
    background-color: v-bind('cor');
    width: v-bind('largura');
    height: v-bind('altura');
    min-height: v-bind('expansivel ? "50px":minAltura');
    border-radius: 10px;
    box-shadow: v-bind('sombreado ? "-1px 1px 4px 2px #DCDADA":sombreado');
    /* transition: .5s; */
    overflow: hidden;
    display: flex;
    flex-direction: column;
    margin: v-bind('margem');
    flex: v-bind('larguraCResumoLateral ? "1":larguraCResumoLateral');
}

.g-card-sombreado{
    box-shadow: v-bind('sombreado ? "0px 4px 5px 3px rgba(0, 0, 0, 0.2)":sombreado');
}
.g-card-border-radius {
    border-radius: 10px;
}

.g-card-fechado{
    height: auto !important;
}


.g-card-cabecalho {
    display: v-bind('displayCabecalho');
    grid-template-columns: v-bind(cardTemplateColumns);
    grid-template-rows: 1fr;
    grid-template-areas: v-bind('cardGridAreas');
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    padding: v-bind('paddingFiltro');
    background-color: v-bind('corCabecalho');
    font-family: v-bind('fonteTitulo');
}

div#conteudoCard.g-card-conteudo-fechado{
    padding: 0px !important;
    height: 0px !important;
    border: none !important;
}
.g-card-custom-header{
    width: 85%;
    flex-grow: 1;
}

.g-card-cabecalho-divisor{
    border-bottom: 1px solid #cecece;
}

.g-card-icone-esquerda {
    display: flex;
    justify-content: space-between;
    align-items: center;
    grid-area: icone-esquerda;
}

.g-card-img-icone-esquerda{
    width: 32px;
}

.g-card-titulo {
    grid-area: titulo;
    font-size: v-bind('fontSizeTitulo');
    align-self: center;
    text-align: left;
    font-weight: v-bind('weightTitulo');
    color: v-bind('corTitulo');

}

.g-card-icone-direita {
    display: flex;
    justify-content: center;
    align-items: center;
    grid-area: icone-direita;
}

.g-card-img-icone-direita{
    width: 24px;
}

.g-card-icone-expandir {
   display: flex;
    justify-content: flex-end;
    align-items: center;
    grid-area: icone-expandir;
    padding: 0 20px 0 20px;
}

.g-card-img-icone-expandir {
    width: 24px;
    transition: .9s;
    transform: rotate(v-bind('rotacaoIconeExpandir'));
}

.g-card-conteudo{
    border-top: v-bind('borderTopConteudo');
    padding: v-bind('paddingDefault');
    height: 100%;
    overflow: hidden;
}

.p-accordion-header{
    display: none !important;
}

/* div#containerCard {
    margin-top: 70px;
} */

</style>
